const PREFIX = 'STOCK_';

const stockConstants = {
  LOOKUP_CATE_REQUEST: PREFIX + 'LOOKUP_CATE_REQUEST',
  LOOKUP_CATE_SUCCESS: PREFIX + 'LOOKUP_CATE_SUCCESS',
  LOOKUP_CATE_FAILURE: PREFIX + 'LOOKUP_CATE_FAILURE',
};

export default stockConstants;
